import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConsumerLoginApiService } from './consumer-login-api.service';

/* eslint-disable @typescript-eslint/naming-convention */
interface ApiRequest {
    Email: string;
    OrganizationId: string;
    StoreName?: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

@Injectable({ providedIn: 'root' })
export class SmsService {
    private readonly apiService = inject(ConsumerLoginApiService);

    sendVerificationCode(email: string, organizationId: string, storeName?: string): Observable<void> {
        /* eslint-disable @typescript-eslint/naming-convention */
        const body: ApiRequest = {
            Email: email,
            OrganizationId: organizationId,
            StoreName: storeName
        };
        /* eslint-enable @typescript-eslint/naming-convention */
        return this.apiService.add<void>('auth', 'sms/send-verification-code', body);
    }
}
